import { useDispatch } from "react-redux";
import { ACTIONS, API_URL, URLS } from "../_config"
import { useEffect, useState } from "react"
// import { countryFlag } from "../_common/functions";
import { useSelectedCountry } from "../_common/hooks/authHook";

const GeneralInfo = () => {
  const [ipInfo, setIpInfo] = useState<any>(null);
  const [countries, setCountries] = useState<any>([]);
  const dispatch = useDispatch();
  const selectedCountry: any = useSelectedCountry();

  // console.log('selectedCountry GeneralInfo==============', selectedCountry);

  const getFlagEmoji = (countryCode: string): string => {
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map((char: string) => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  };

  const markCountryReady = () => {
    dispatch({ type: ACTIONS.GEN_INFO.COUNTRY_READY, payload: { countryReady: true } });
  }

  const getMenuList = async (sCountryId: any) => {
    try {
      const response = await fetch((API_URL.GENERAL_INFO.MENU_LIST(sCountryId)));
      const resp = await response.json();
      dispatch({ type: ACTIONS.GEN_INFO.MENU_LIST, payload: { menus: resp.data } });
    } catch (error) {
      console.log('Error occurred while making the API request.');
    }
  }

  const getCountryList = async () => {
    try {
      const response = await fetch((API_URL.GENERAL_INFO.COUNTRY_LIST));
      const resp = await response.json();
      console.log('resp', resp.data)
      if (resp?.data && resp?.data.length > 0) {
        resp.data.map((country: any) => {
          country.label = getFlagEmoji(country?.country_code) + " " + country.country_name;
          country.value = country.country_code;
        })
        setCountries(resp.data);
        dispatch({ type: ACTIONS.GEN_INFO.COUNTRY_LIST, payload: { countries: resp.data } });

        getClientIP();
      } else {
        markCountryReady();
      }
    } catch (error) {
      console.log('Error occurred while making the API request.');
      markCountryReady();
    }
  }

  const getClientIP = async () => {
    // https://ipinfo.io/json?token=your_api_token
    await fetch("https://api64.ipify.org?format=json")
      .then((res) => {
        // console.log('res', res);
        return res.json();
      })
      .then(async (data) => {
        if (data.ip) {
          await fetch(`https://ipinfo.io/${data.ip}/json?token=44fcafe6984295`)
            .then((res) => res.json())
            .then((data) => {

              console.log('IP Info:', data);
              if (data.ip != ipInfo?.ip) {
                setIpInfo(data)
                chooseCountry();
              }
              setIpInfo(data)
            })
            .catch((err) => { console.error("Error fetching IP:", err); markCountryReady(); });
        } else {
          markCountryReady();
        }
      })
      .catch((err) => { console.error("Error fetching IP:", err); markCountryReady(); });
  }

  const chooseCountry = () => {
    if (ipInfo) {
      let countryCode = ipInfo.country;
      // console.log('countryCode-----------------', countryCode, countries);
      let country = [];
      country = countries.find((c: any) => {
        if (c.country_code == countryCode) {
          // console.log('Match user ip country set====', countries);
          // getMenuList(c.id);
          dispatch({ type: ACTIONS.GEN_INFO.SELECTED_COUNTRY, payload: { selectedCountry: c } });
          return c;
        }
      }) || [];

      if (country.length == 0) {
        countries.map((c: any) => {
          if (c.is_default == 1) {
            // console.log('Default country set====', c);
            // getMenuList(c.id);
            dispatch({ type: ACTIONS.GEN_INFO.SELECTED_COUNTRY, payload: { selectedCountry: c } });
          }
          return c;
        });
        // console.log('Select default country====', country);
      }
      markCountryReady();
    }
  }

  useEffect(() => {
    getCountryList();
    // getClientIP();
    const readyTimeoutId = setTimeout(() => markCountryReady(), 8000);
    return () => clearTimeout(readyTimeoutId);
  }, [])

  useEffect(() => {
    // if (!selectedCountry) {
    if (selectedCountry?.country_code != ipInfo?.country) {
      chooseCountry();
    }
    // }
  }, [ipInfo])

  useEffect(() => {
    if (!selectedCountry) return;
    getMenuList(selectedCountry?.id);
  }, [selectedCountry])

  return (
    <></>
  )
}

export default GeneralInfo
